import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

function NCC() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="NCC/NSS" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">                                    
                                    <h3>NCC/NSS OFFICE ORDER</h3>
                                </div>
                                <p>
                               This is to inform you all that the Competent Authorities have made important decisions
regarding the allocation of additional responsibilities within our University. Effective
immediately, the following staff members have been appointed as NSS Coordinators:
                                </p>
                                <table className='table table-bordered tdfix'>
                                    {/* <thead className='table-light head_red'>
                                        <tr>
                                            <th scope="col">Sr. No.</th>
                                            <th scope="col">Particulars</th>
                                            <th scope="col">Details</th>
                                        </tr>
                                    </thead> */}
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Mr. Parshant Kumar, Assistant Professor</td>
                                            <td>SOPS</td>
                                            <td>University Coordinator</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Mr. Rahul, Assistant Professor</td>
                                            <td>SOSH</td>
                                            <td>SOSH Coordinator</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Ms. Rinki, Assistant Professor</td>
                                            <td>SOAHS</td>
                                            <td>SOAHS Coordinator</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>Ms. Savita, Assistant Professor</td>
                                            <td>SOET</td>
                                            <td>SOET Coordinator</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>Mr. Yogesh, Assistant Professor</td>
                                            <td>SOPS</td>
                                            <td>SOPS Coordinator</td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>Ms. Anju Tiwari, Assistant Professor</td>
                                            <td>SBMC</td>
                                            <td>SBMC Coordinator</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>Mr. Arun Tyagi, Assistant Professor</td>
                                            <td>SOL</td>
                                            <td>SOL Coordinator</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p>We believe that these individuals will bring valuable leadership and dedication to their
new roles, further enhancing our commitment to community service and engagement.</p>
<p>Thank you for your attention and support as we transition into this new phase.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default NCC